import React from 'react'
import { DashboardLayout } from '../../patientLayouts'
import SelectPatientComponent from '../../components/PatientDetailsInfo/SelectPatient'
const SelectPatient = () => {
  return (
    <DashboardLayout noNavbar={'true'}>
      <SelectPatientComponent />
    </DashboardLayout>
  )
}

export default SelectPatient
